import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu']

  connect () {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
  }

  disconnect () {
    document.removeEventListener('click', this.boundHandleClickOutside)
  }

  toggle (event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.menuTarget.classList.contains('hidden')) {
      this.show()
    } else {
      this.hide()
    }
  }

  show () {
    this.menuTarget.classList.remove('hidden')
    document.addEventListener('click', this.boundHandleClickOutside)
  }

  hide () {
    this.menuTarget.classList.add('hidden')
    document.removeEventListener('click', this.boundHandleClickOutside)
  }

  handleClickOutside (event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
}
